import { Icon, Popconfirm, Table } from 'antd';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { tryDeleteFile } from '../flow/actions';

const defaultProps = {};
const propTypes = {
  isSharedByOthers: PropTypes.bool.isRequired,
  files: PropTypes.array.isRequired
};

class FolderTable extends Component {
  getUrl = record => {
    const { activeFolderType } = this.props;
    if (activeFolderType === 'report') {
      return `/reports/report-setup/${record.type}/${record.id}`;
    } else if (activeFolderType === 'dashboard') {
      return `/dashboards/${record.id}/settings`;
    }
    return '';
  };
  handleDeleteClick = id => {
    this.props.tryDeleteFile(id, this.props.activeFolderType);
  };
  renderColumns = () => {
    const gI18n = 'global.ui';
    const i18n = 'page.ReportListPanel.columns';
    const { isSharedByOthers, activeFolderType } = this.props;
    const actionColumn = [
      {
        key: 'actions',
        title: '',
        width: 60,
        render: (text, record) => {
          return isSharedByOthers ? (
            activeFolderType === 'report' && (
              <Link to={`/reports/${record.id}/real-time/generate`}>
                <Icon
                  type="eye"
                  className="cursor-pointer mr-sm"
                  style={{ fontWeight: 400 }}
                />
              </Link>
            )
          ) : (
            <div>
              <Link to={`${this.getUrl(record)}`}>
                <Icon type="edit" className="cursor-pointer mr-sm" />
              </Link>
              <Popconfirm
                cancelText={<FormattedMessage id={`${gI18n}.button.cancel`} />}
                okText={<FormattedMessage id={`${gI18n}.button.ok`} />}
                title={<FormattedMessage id={`${gI18n}.dialog.deleteTitle`} />}
                onConfirm={() => this.handleDeleteClick(record.id)}
              >
                <Icon type="delete" className="cursor-pointer" />
              </Popconfirm>
            </div>
          );
        }
      }
    ];

    const columnsOnType =
      this.props.activeFolderType === 'dashboard'
        ? [
            {
              dataIndex: 'name',
              title: <FormattedMessage id={`${i18n}.dName`} />
            }
          ]
        : [
            {
              dataIndex: 'name',
              title: <FormattedMessage id={`${i18n}.name`} />
            },
            {
              dataIndex: 'type',
              title: <FormattedMessage id={`${i18n}.type`} />
            }
          ];

    const commonColumns = [
      {
        dataIndex: 'createdAt',
        title: <FormattedMessage id={`${i18n}.createdAt`} />
      }
    ];
    return [...actionColumn, ...columnsOnType, ...commonColumns];
  };

  render() {
    const { files } = this.props;
    return (
      <Table
        dataSource={files}
        columns={this.renderColumns()}
        pagination={false}
        size="small"
        rowKey="id"
      />
    );
  }
}

const mapStateToProps = ({ reportList }) => ({
  files: reportList.files
});
const mapDispatchToProps = {
  tryDeleteFile
};
FolderTable.defaultProps = defaultProps;
FolderTable.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FolderTable);



// WEBPACK FOOTER //
// ./src/views/ReportListPanel/components/Table.jsx